import { prefix as pathPrefix } from "config";
import React, { useState } from "react";
import "./index.scss";
import { YituLogo } from "../AppHeader";
import { AdaptionSection } from "components/AdaptionSection";
import { Col, Row } from "antd";
import { BusinessConsultModal } from "components/BusinessConsultModal";
import { BecomePartnerModal } from "components/BecomePartnerModal";

const AppFooterSection: React.SFC<{
  title?: React.ReactNode;
}> = props => {
  const prefix = "AppFooterSection";
  return (
    <div className={prefix}>
      <div className={`${prefix}-title`}>{props.title}</div>
      <div className={`${prefix}-body`}>{props.children}</div>
    </div>
  );
};

const AppFooterLink: React.SFC<{
  href?: string;
  onClick?: () => void;
}> = props => {
  const prefix = "AppFooterLink";
  const { href, children, onClick } = props;
  return (
    <a className={prefix} href={href} onClick={onClick}>
      {children}
    </a>
  );
};

export const AppFooterDescription = () => {
  const prefix = "AppFooterDescription";
  const [partnerModalVisible, setPartnerModalVisible] = useState(false);
  const [consultModalVisible, setConsultModalVisible] = useState(false);

  return (
    <div className={prefix}>
      {/** 商标 */}
      <YituLogo className={`${prefix}-logo`} />
      {/** 1 */}
      <AppFooterSection title={"关于依图"}>
        <AppFooterLink href="https://www.yitutech.com/cn/about-us?hash=team">
          创始团队
        </AppFooterLink>
        <AppFooterLink href="https://www.yitutech.com/cn/about-us?hash=history">
          大事记
        </AppFooterLink>
        <AppFooterLink href="https://www.yitutech.com/cn/news">
          依图新闻
        </AppFooterLink>
        <AppFooterLink href={`${pathPrefix}/#activity`}>活动资讯</AppFooterLink>
      </AppFooterSection>
      {/** 2 */}
      <AppFooterSection title={"如何购买"}>
        <AppFooterLink onClick={() => setConsultModalVisible(true)}>
          业务咨询
        </AppFooterLink>
        <AppFooterLink href={`${pathPrefix}/searchPartner`}>
          查找伙伴
        </AppFooterLink>
      </AppFooterSection>
      {/** 3 */}
      <AppFooterSection title={"加入我们"}>
        <AppFooterLink onClick={() => setPartnerModalVisible(true)}>
          成为伙伴
        </AppFooterLink>
        <AppFooterLink>邮箱: partners@yitu-inc.com</AppFooterLink>
      </AppFooterSection>

      {/** 模态框 */}
      <BecomePartnerModal
        visible={partnerModalVisible}
        onClose={() => setPartnerModalVisible(false)}
      />
      <BusinessConsultModal
        visible={consultModalVisible}
        onClose={() => setConsultModalVisible(false)}
      />
    </div>
  );
};

/**
 * 地址
 */
export const AppFooterAddress = () => {
  const prefix = "AppFooterAddress";
  return (
    <Row className={prefix} gutter={16}>
      <Col xs={24} md={8}>
        <div>上海：上海市徐汇区西岸国际人工智能中心云锦路701号21楼</div>
        <div>总机：021 - 52559588</div>
      </Col>
      <Col xs={24} md={8}>
        <div>北京：北京市海淀区科学院南路2号融科资讯中心C座南楼19F</div>
        <div>总机：010 - 83433999</div>
      </Col>
      <Col xs={24} md={8}>
        <div>杭州：杭州市西湖区古墩路87号浙商财富中心3号楼10楼</div>
        <div>总机：0571 - 87317518</div>
      </Col>
      <Col className={`${prefix}-right`} span={24}>
        版权所有&nbsp; ©&nbsp; 上海依图网络科技有限公司&nbsp; 2012-2020&nbsp;
        沪ICP备14000593号-2&nbsp; 沪公网安备31010502003345号&nbsp;
        增值电信经营许可证：沪B2-20190650
      </Col>
    </Row>
  );
};

export const AppFooter = () => {
  const prefix = "AppFooter";
  return (
    <div className={prefix}>
      <AdaptionSection>
        {/** 各种链接 */}
        <AppFooterDescription />
        {/** 版权和公司地址 */}
        <AppFooterAddress />
      </AdaptionSection>
    </div>
  );
};
